import process from "shelljs";
import authHeader from "./auth-header";
import http from "./http-common";

const API_URL = process.env.BFF_URL;

class AuthServiceApi {
  login(data) {
    return http.post(API_URL + "/auth/login", data);
  }

  register(user) {
    return http.post(API_URL + "/auth/register", user);
  }

  verifyAccount(data) {
    return http.post(API_URL + `/auth/register/verify`, data);
  }

  activateAccount(data) {
    return http.post(API_URL + `/auth/register/activate`, data);
  }

  resendVerificationCode(data) {
    return http.post(API_URL + `/auth/register/resend-code`, data);
  }

  requestPasswordReset(data) {
    return http.post(API_URL + `/auth/password/request-reset`, data);
  }

  resetPassword(data) {
    return http.post(API_URL + `/auth/password/reset`, data);
  }

  acceptInvite(id, data) {
    return http.put(API_URL + `/auth/invitations/${id}/accept`, data, {
      headers: authHeader()
    });
  }

  rejectInvite(id, data) {
    return http.put(API_URL + `/auth/invitations/${id}/reject`, data, {
      headers: authHeader()
    });
  }

  findInviteById(id, token) {
    return http.get(API_URL + `/auth/invitations/${id}?token=${token}`, {
      headers: authHeader()
    });
  }

  validateInvitationCode(code) {
    return http.get(API_URL + `/auth/invitations/validate?token=${code}`);
  }

  userExists(email, token) {
    return http.get(API_URL + `/auth/users/${email}?token=${token}`, {
      headers: authHeader()
    });
  }
}

export default new AuthServiceApi();



// WEBPACK FOOTER //
// ./src/service/AuthServiceApi.js